import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMeals = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#ffad77",
	...props,
	children: /* @__PURE__ */ _jsxs("g", { children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M13.6 6.49927H2.4C1.6268 6.49927 1 7.2828 1 8.24927C1 9.21573 1.6268 9.99927 2.4 9.99927H13.6C14.3732 9.99927 15 9.21573 15 8.24927C15 7.2828 14.3732 6.49927 13.6 6.49927Z",
			fill: "currentColor",
			fillOpacity: .25,
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.0669 5.89387V6.00195C14.0669 5.47635 13.9673 4.9559 13.7737 4.47032C13.5802 3.98474 13.2964 3.54354 12.9388 3.17191C12.5811 2.80029 12.1565 2.50552 11.6892 2.30444C11.2219 2.10336 10.7211 1.99992 10.2154 2H5.78515C5.27938 1.99992 4.77856 2.10336 4.31127 2.30444C3.84398 2.50552 3.41939 2.80029 3.06173 3.17191C2.70407 3.54354 2.42035 3.98474 2.22679 4.47032C2.03322 4.9559 1.93359 5.47635 1.93359 6.00195V5.89387",
			fill: "currentColor",
			fillOpacity: .25
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.0669 5.89387V6.00195C14.0669 5.47635 13.9673 4.9559 13.7737 4.47032C13.5802 3.98474 13.2964 3.54354 12.9388 3.17191C12.5811 2.80029 12.1565 2.50552 11.6892 2.30444C11.2219 2.10336 10.7211 1.99992 10.2154 2H5.78515C5.27938 1.99992 4.77856 2.10336 4.31127 2.30444C3.84398 2.50552 3.41939 2.80029 3.06173 3.17191C2.70407 3.54354 2.42035 3.98474 2.22679 4.47032C2.03322 4.9559 1.93359 5.47635 1.93359 6.00195V5.89387",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14 10.4993V11.5546C14 12.0703 13.8055 12.565 13.4593 12.9297C13.113 13.2944 12.6434 13.4993 12.1538 13.4993H3.84615C3.35652 13.4993 2.88695 13.2944 2.54073 12.9297C2.1945 12.565 2 12.0703 2 11.5546V10.4993",
			fill: "currentColor",
			fillOpacity: .25
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14 10.4993V11.5546C14 12.0703 13.8055 12.565 13.4593 12.9297C13.113 13.2944 12.6434 13.4993 12.1538 13.4993H3.84615C3.35652 13.4993 2.88695 13.2944 2.54073 12.9297C2.1945 12.565 2 12.0703 2 11.5546V10.4993",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	] })
});
export default SvgMeals;
